<template>
  <v-sheet
    class="w-100 pa-4 my-4"
    border
    rounded
    elevation="1"
    color="background"
  >
    <div
      class="d-flex flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row"
    >
      <!-- Content div -->
      <div class="flex-grow-1">
        <!-- Icono y título de estatus -->
        <div class="d-flex align-center">
          <v-icon
            v-if="elementos && elementos.length > 0"
            :color="elementos[0].color"
            :icon="elementos[0].icono"
            size="small"
            class="me-2"
          ></v-icon>
          <p
            class="text-body-1 font-weight-bold text-uppercase"
            :class="
              elementos && elementos.length > 0 ? elementos[0].texto_color : ''
            "
          >
            {{ t("estatus-forma.etiqueta") }}:
            {{ t("estatus-forma." + estatus + ".titulo") }}
          </p>
        </div>
        <!-- Comentarios de revisión de operaciones -->
        <div
          class="text-body-1 text-textDark text-justify mt-2 pl-6"
          v-if="estatus == 4 && historial_revision"
        >
          {{ historial_revision.comentarios }}
          <!-- imágenes de historia revisión -->
          <div
            v-if="(historial_revision.imagenes_revision || []).length > 0"
            class="mt-4"
          >
            <listado-archivo
              :listado="historial_revision.imagenes_revision"
              :titulo="t('imagenes')"
              tipo="imagen_revision"
              :borrar="0"
            >
            </listado-archivo>
          </div>
        </div>
        <!-- Texto fijo de estatus -->
        <div class="text-body-1 text-justify mt-2 pl-6" v-else>
          <p class="text-textDark">
            {{ t("estatus-forma." + estatus + ".texto") }}
          </p>
        </div>
      </div>
    </div>
  </v-sheet>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { router } from "@inertiajs/vue3";
import { computed } from "vue";

const { t } = useI18n();

const props = defineProps({
  item: Object, // objeto completo (colgantes)
  stand: Number, // identificador del stand
  id: Number, // identificador del registro
  estatus: Number,
  elementos: Array,
  historial_revision: Object,
});

// Computed properties para extraer valores de item si se proporciona
const standId = computed(() => {
  if (props.item) {
    // Intentar obtener stand_id de diferentes formas
    if (props.item.stand_id) return props.item.stand_id;
    if (props.item.stand?.id) return props.item.stand.id;
    if (props.item.stand_id) return props.item.stand_id;
  }
  return props.stand;
});

const itemId = computed(() => {
  if (props.item) {
    return props.item.id;
  }
  return props.id;
});

// Función helper para obtener icono según estatus
const getIconoByEstatus = (estatus) => {
  const iconos = {
    0: "mdi-alert-circle",
    1: "mdi-clock-outline",
    2: "mdi-check-circle",
    3: "mdi-check-circle",
    4: "mdi-alert",
    5: "mdi-alert",
  };
  return iconos[estatus] || "mdi-information";
};

const estatus = computed(() => {
  const fromItem = props.item?.estatus;
  if (fromItem !== undefined && fromItem !== null) {
    return fromItem;
  }
  return props.estatus;
});

const elementos = computed(() => {
  if (props.elementos) {
    return props.elementos;
  }
  if (props.item) {
    // Si tiene estatus_elementos
    if (props.item.estatus_elementos) {
      return props.item.estatus_elementos;
    }
  }
  return [];
});
</script>
